
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import 'toastr/build/toastr.min.css';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import landingpage from './pages/landingpage/landingpage'
import aboutus from './pages/aboutus/aboutus'
import contactpage from './pages/contactpage/contactpage'
import estudios5k5d2 from './pages/estudios5k5d2/estudios5k5d2'
import visualizacindeunestudio2mm3bj from './pages/visualizacindeunestudio2mm3bj/visualizacindeunestudio2mm3bj'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={landingpage} />
			<Route exact path="/acerca" component={aboutus} />
			<Route exact path="/contact" component={contactpage} />
			<Route exact path="/estudios" component={estudios5k5d2} />
			<Route exact path="/estudios/:id" component={visualizacindeunestudio2mm3bj} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

